<template>
  <ModalProvider 
    id="modalAsignarEncargadoProveedor" 
    ref="modalTransporte"
    :is-form="false"
    :hide-header="true"
    style="margin-top: 50px"
  >
    <template #custom-header>
      <TabsProvider 
        v-if="current" 
        :tabs="tabsConfig" 
        :value="estadoForm" 
        @input="cambiarTab" 
      />
    </template>

    <template #body="{ hide }">
      
      <transition :name="transitionName" mode="out-in">
        <!-- ============================================================= -->
        <!-- TAB 0 — Transporte del Proveedor                              -->
        <!-- ============================================================= -->
        <div v-if="estadoForm === 0" key="tab0">
          <div class="row mx-0 mt-4">
            <div class="my-2 col-12">
              <div class="text-center">
                <h5 class="modal-title" id="createModalLabel">Encargado del Transporte de Proveedor</h5>

                <div class="row mx-0 d-flex justify-content-center mt-4">
                  <div class="col-12 mb-0 text-left">
                    <InputProvider 
                      label="Nombre del Encargado"
                      placeholder="Nombre" 
                      v-model="nombreEncargado"
                      type="text"
                      :disabled="isTransporteBloqueado"
                    />
                  </div>
                  <div class="col-12 mb-0 text-left position-relative">
                    <InputProvider 
                      label="DPI del Encargado"
                      placeholder="DPI" 
                      v-model="dpiEncargado"
                      @input="dpiEncargado = dpiEncargado.replace(/[-\s]/g, '')"
                      type="text"
                      minlength="13"
                      maxlength="13"
                      :disabled="isTransporteBloqueado"
                    />
                    <span 
                      class="position-absolute text-muted" 
                      style="right: 25px; bottom: 25px; pointer-events: none; font-size: 0.9em;"
                      v-if="dpiEncargado.length < 13 && !isTransporteBloqueado"
                    >
                      {{ dpiEncargado.length }} / 13
                    </span>
                  </div>
                  <div class="col-12 mb-2 text-left">
                    <InputProvider 
                      label="Matrícula del Vehículo"
                      placeholder="Placa/Matrícula" 
                      v-model="matriculaEncargado"
                      type="text"
                      :disabled="isTransporteBloqueado"
                    />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>


        <!-- ============================================================= -->
        <!-- TAB 1 — Transporte Tercerizado                                -->
        <!-- ============================================================= -->
        <div v-else-if="estadoForm === 1" key="tab1">
          <div class="row mx-0 mt-4">
            <div class="my-2 col-12">
              <div class="text-center">
                <h5 class="modal-title">Datos de Transporte Tercerizado</h5>

                <div class="row mx-0 d-flex justify-content-center mt-3 text-left">

                  <!-- Selector de empresa -->
                  <div class="col-12 mb-3">
                    <label class="font-weight-bold">Empresa de Transporte</label>
                    <select
                      class="form-control py-2"
                      v-model="tercerizado.empresa"
                      :disabled="isTransporteBloqueado"
                    >
                      <option value="">— Seleccionar empresa —</option>
                      <option v-for="op in opcionesEmpresa" :key="op.value" :value="op.value">
                        {{ op.label }}
                      </option>
                    </select>
                  </div>

                  <!-- Campo libre cuando es "Otra" -->
                  <div class="col-12 mb-3" v-if="tercerizado.empresa === 'OT'">
                    <InputProvider
                      label="Nombre de la Empresa"
                      placeholder="Ingresa el nombre"
                      v-model="tercerizado.nombre_otra"
                      type="text"
                      :disabled="isTransporteBloqueado"
                    />
                  </div>

                  <!-- Agregar guías -->
                  <div class="col-12 mb-2">
                    <label class="font-weight-bold">Guías de Transporte</label>
                    <div class="input-group mb-2" v-if="!isTransporteBloqueado">
                      <input
                        class="form-control"
                        placeholder="Número de guía"
                        v-model="nuevaGuia"
                        type="text"
                        @keyup.enter="agregarGuia"
                      />
                      <div class="input-group-append">
                        <button class="btn btn-dark" type="button" @click="agregarGuia">
                          <i class="fas fa-plus"></i>
                        </button>
                      </div>
                    </div>

                    <!-- Tabla de guías -->
                    <!-- Vista de rastreo (Bloqueado) -->
                    <div v-if="tercerizado.guias.length && isTransporteBloqueado">
                      <div 
                        class="btn btn-outline-success radius_custom_green btn-block py-3 mb-2" 
                        v-for="(g, idx) in tercerizado.guias" 
                        :key="idx"
                        @click="irSeguimiento(tercerizado.empresa, g)"
                        style="cursor: pointer;"
                        :title="tieneSeguimiento(tercerizado.empresa) ? 'Click para rastrear guía' : 'Click para copiar guía'"
                      >
                        {{ g }}
                        <i v-if="tieneSeguimiento(tercerizado.empresa)" class="fas fa-external-link-alt ml-2"></i>
                        <i v-else class="fas fa-copy ml-2"></i>
                      </div>
                    </div>

                    <!-- Vista de edición (No bloqueado) -->
                    <table class="table table-sm table-bordered mt-3" v-if="tercerizado.guias.length && !isTransporteBloqueado">
                      <thead>
                        <tr>
                          <th>Número de Guía</th>
                          <th v-if="!isTransporteBloqueado"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(g, idx) in tercerizado.guias" :key="idx">
                          <td>{{ g }}</td>
                          <td v-if="!isTransporteBloqueado" class="text-center">
                            <button class="btn btn-outline-danger btn-sm" @click="quitarGuia(idx)">
                              <i class="fas fa-times"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <small class="text-muted" v-if="!tercerizado.guias.length">
                      <i class="fas fa-info-circle"></i> Agrega al menos una guía.
                    </small>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </template>

    <template #footer="{ hide }">
      <div class="d-flex flex-row flex-nowrap justify-content-between border-0 p-0 m-0 w-100">
        <ButtonProvider 
          v-if="estadoForm === 0"
          @click="guardarEncargado()" 
          class="w-50 py-3 mr-1"
          variant="success"
          icon="fa-save"
          label="Guardar"
          :disabled="!nombreEncargado || !dpiEncargado || dpiEncargado.length < 13 || !matriculaEncargado || isTransporteBloqueado"
        />
        <ButtonProvider 
          v-else-if="estadoForm === 1"
          @click="guardarTercerizado()" 
          class="w-50 py-3 mr-1"
          variant="success"
          icon="fa-save"
          label="Guardar"
          :disabled="!tercerizado.empresa || (tercerizado.empresa === 'OT' && !tercerizado.nombre_otra) || !tercerizado.guias.length || isTransporteBloqueado"
        />
        <ButtonProvider 
          @click="closeModal()" 
          type="button" 
          class="w-50 py-3 ml-1"
          variant="secondary"
          label="Cancelar"
        />
      </div>
    </template>
  </ModalProvider>
</template>
<script>
import Notifications from "@/notifications/notifications";
import RecepcionService from "@/services/wms/RecepcionService";
import { ModalProvider, InputProvider, ButtonProvider, TabsProvider } from "@/components/atomic";

export default {
  components: {
    ModalProvider,
    InputProvider,
    ButtonProvider,
    TabsProvider
  },
  inject: {
    refreshRecepcion: {
      from: 'refreshRecepcion',
      default: () => {}
    },
  },
  props: {
    current: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      // Tab 0 — Encargado proveedor
      nombreEncargado: "",
      dpiEncargado: "",
      matriculaEncargado: "",
      // Tab 1 — Tercerizado
      tercerizado: {
        empresa: "",
        nombre_otra: "",
        guias: [],
      },
      nuevaGuia: "",
      opcionesEmpresa: [],
      estadoForm: 0,
      transitionName: "slide-left",
    };
  },
  computed: {
    /** Bloqueo global: ya tiene cualquier tipo de transporte asignado → solo lectura */
    isTransporteBloqueado() {
      return this.tieneEncargado || this.tieneTercerizado;
    },
    tieneEncargado() {
      if (!this.current) return false;
      return !!(this.current.encargado_nombre && this.current.encargado_dpi && this.current.encargado_matricula);
    },
    tieneTercerizado() {
      if (!this.current) return false;
      return !!this.current.transporte_tercerizado;
    },
    tabsConfig() {
      return [
        {
          label: "Transporte Proveedor",
          value: 0,
          disabled: this.tieneTercerizado
        },
        {
          label: "Transporte Tercerizado",
          value: 1,
          disabled: this.tieneEncargado
        }
      ];
    }
  },
  watch: {
    current: {
      handler(val) {
        if (val) {
          this.poblarDatos();
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.obtenerChoices();
    const modal = $('#modalAsignarEncargadoProveedor');
    
    modal.on('show.bs.modal', () => {
      this.poblarDatos();
    });

    modal.on('hide.bs.modal', () => {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      this.limpiarFormularios();
    });
  },
  methods: {
    cambiarTab(index) {
      if (this.estadoForm === index) return;
      this.limpiarFormularios();
      this.transitionName = index < this.estadoForm ? "slide-left" : "slide-right";
      this.estadoForm = index;
    },
    limpiarFormularios() {
      this.nombreEncargado = "";
      this.dpiEncargado = "";
      this.matriculaEncargado = "";
      this.tercerizado = {
        empresa: "",
        nombre_otra: "",
        guias: [],
      };
      this.nuevaGuia = "";
    },
    poblarDatos() {
      if (!this.current) return;
      
      // Poblar tab 0
      this.nombreEncargado = this.current.encargado_nombre || "";
      this.dpiEncargado = this.current.encargado_dpi || "";
      this.matriculaEncargado = this.current.encargado_matricula || "";

      // Poblar tab 1 si ya existe tercerizado
      if (this.current.transporte_tercerizado_obj) {
        const t = this.current.transporte_tercerizado_obj;
        this.tercerizado.empresa = t.empresa || "";
        this.tercerizado.nombre_otra = t.nombre_otra || "";
        this.tercerizado.guias = (t.guias || []).map(g => g.numero_guia);
        this.estadoForm = 1;
      } else {
        this.tercerizado = { empresa: "", nombre_otra: "", guias: [] };
        if (this.tieneEncargado) {
          this.estadoForm = 0;
        }
      }
    },
    obtenerChoices() {
      RecepcionService.obtenerChoicesEmpresa()
        .then(res => {
          this.opcionesEmpresa = res.data;
        })
        .catch(() => {
          console.error("Error al obtener las opciones de empresa.");
        });
    },

    closeModal() {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      this.limpiarFormularios();
      $("#modalAsignarEncargadoProveedor").modal("hide");
    },

    // ── Tab 0 ──
    guardarEncargado() {
      const self = this;
      const params = {
        encargado_nombre: self.nombreEncargado,
        encargado_dpi: self.dpiEncargado,
        encargado_matricula: self.matriculaEncargado,
      };
      RecepcionService.asignarEncargado(self.current.id, params)
        .then(() => {
          Notifications.toast.success("Éxito", "Encargado asignado correctamente.");
          self.refreshRecepcion();
          self.closeModal();
        })
        .catch(() => {
          Notifications.toast.error("Error", "Ocurrió un error al asignar el encargado.");
        });
    },

    // ── Tab 1 ─
    agregarGuia() {
      const g = this.nuevaGuia.trim();
      if (!g) return;
      if (!this.tercerizado.guias.includes(g)) {
        this.tercerizado.guias.push(g);
      }
      this.nuevaGuia = "";
    },

    quitarGuia(idx) {
      this.tercerizado.guias.splice(idx, 1);
    },

    guardarTercerizado() {
      const self = this;
      const params = {
        empresa: self.tercerizado.empresa,
        nombre_otra: self.tercerizado.empresa === 'OT' ? self.tercerizado.nombre_otra : null,
        guias: self.tercerizado.guias,
      };
      RecepcionService.asignarTransporteTercerizado(self.current.id, params)
        .then(() => {
          Notifications.toast.success("Éxito", "Transporte tercerizado asignado correctamente.");
          self.refreshRecepcion();
          self.closeModal();
        })
        .catch(error => {
          const msg = (error.response && error.response.data && error.response.data.detail) || "Ocurrió un error al asignar el transporte.";
          Notifications.toast.error("Error", msg);
        });
    },

    // ── Segumiento de Guías ──
    /**
     * Aqui se agregan las urls de tracking de las empresas de entrega tercerizadas
     * para mapear las variables en los botónes de consulta de Guía de Entrega 
     */ 
    irSeguimiento(empresa, guia) {
      const mapping = {
        'GX': `https://guatex.com/paquete/?tipo=G&sitio-paquete=${guia}`,
        'CE': `https://cargoexpreso.com/tracking/?guia=${guia}#resultado`,
        'FZ': `https://rastreo.forzadelivery.com/${guia}`,
        'TC': `https://www.transportesdecarga.com.gt/tracking/ver_tracking/${guia}`
      };
      const baseUrl = mapping[empresa];
      if (baseUrl && guia) {
        window.open(`${baseUrl}`, '_blank');
      } else if (guia) {
        navigator.clipboard.writeText(guia).then(() => {
          Notifications.toast.success("Copiado", "Número de guía copiado al portapapeles.");
        });
      }
    },

    tieneSeguimiento(empresa) {
      const mapping = {
        'GX': true,
        'CE': true,
        'FZ': true,
        'TC': true
      };
      return !!mapping[empresa];
    },
  }
}
</script>

<style scoped>
.radius_custom_green {
  border: 1px solid #0c9d2e !important;
  background-color: #0c9d2e00 !important;
  border-radius: 25px !important;
}
.radius_custom_green:hover {
  border: 1px solid #0c9d2e !important;
  background-color: #0c9d2e !important;
  color: #fff !important;
  border-radius: 25px !important;
}

/* Animaciones direccionales Slide + Fade */
.slide-left-enter-active, .slide-left-leave-active,
.slide-right-enter-active, .slide-right-leave-active {
  transition: all 0.3s ease;
}

/* Slide Left: De Derecha a Izquierda (Volver a 0) */
.slide-left-enter {
  opacity: 0;
  transform: translateX(30px);
}
.slide-left-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

/* Slide Right: De Izquierda a Derecha (Ir a 1) */
.slide-right-enter {
  opacity: 0;
  transform: translateX(-30px);
}
.slide-right-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
